module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_null@2x.c47c2ce0.png";